import React from 'react';
import SectionTitle from '../SectionTitle';
import { usePermitRequestContext } from '../../../../contexts/PermitRequestContext';
import FormSection from './FormSection';
import { monthsSelectOption, yearsSelectOption } from '../../../../data/craditCardForm.data';
import InputGroup from '../../../../components/form/InputGroup';
import SelectInput from '../../../../components/form/selects/SelectInput';
import { useTags } from '../../../../hooks/useTags';
import addRequestPageLang from '../../../../data/lang/add-request-page.lang';
import { formatCurrencyNis } from '../../../../helpers/formating-currency';
import formErrorsLang from '../../../../data/lang/form-errors.lang';


function CreditCardFormSection() {
    const { handleChange, Formik } = usePermitRequestContext();

    const { errors, values, touched, handleBlur } = Formik;
    const payment = values.paymentAmount;
    const craditCardDetails = values.craditCard;
    const craditCardErrors = errors.craditCard ? errors.craditCard : {};
    const craditCardTouched = touched.craditCard ? touched.craditCard : {};

    const hasPayment = payment > 0 ? true : false;

    const generateTag = useTags();

    const sectionTitle = generateTag(addRequestPageLang, 'form.payment-section.title');

    // Define variables for Hebrew tags
    const title = `${sectionTitle} - ${formatCurrencyNis(payment)}`;
    const cardNumberLabel = generateTag(addRequestPageLang, 'form.payment-section.card-number-label');
    const cardExpireYearLabel = generateTag(addRequestPageLang, 'form.payment-section.card-expire-year-label');
    const cardExpireMonthLabel = generateTag(addRequestPageLang, 'form.payment-section.card-expire-month-label');
    const cardCVVLabel = generateTag(addRequestPageLang, 'form.payment-section.card-cvv-label');
    const cardHolderIdLabel = generateTag(addRequestPageLang, 'form.payment-section.card-holder-id-label');
    const cardHolderNameLabel = generateTag(addRequestPageLang, 'form.payment-section.card-holder-name-label');

    const cardNumberTouched = craditCardTouched.cardNumber;
    const cardNumberError = craditCardErrors.cardNumber;
    const cardNumberMsg = generateTag(formErrorsLang, cardNumberError && cardNumberTouched ? cardNumberError : '');

    const cardExpireYearTouched = craditCardTouched.cardExpireDateYY;
    const cardExpireYearError = craditCardErrors.cardExpireDateYY;
    const cardExpireYearMsg = generateTag(formErrorsLang, cardExpireYearError && cardExpireYearTouched ? cardExpireYearError : '');

    const cardExpireMonthTouched = craditCardTouched.cardExpireDateMM;
    const cardExpireMonthError = craditCardErrors.cardExpireDateMM;
    const cardExpireMonthMsg = generateTag(formErrorsLang, cardExpireMonthError && cardExpireMonthTouched ? cardExpireMonthError : '');

    const cardCVVTouched = craditCardTouched.cardAddedNumber;
    const cardCVVError = craditCardErrors.cardAddedNumber;
    const cardCVVMsg = generateTag(formErrorsLang, cardCVVError && cardCVVTouched ? cardCVVError : '');

    const cardHolderIdTouched = craditCardTouched.cardHolderId;
    const cardHolderIdError = craditCardErrors.cardHolderId;
    const cardHolderIdMsg = generateTag(formErrorsLang, cardHolderIdError && cardHolderIdTouched ? cardHolderIdError : '');

    const cardHolderNameTouched = craditCardTouched.cardHolderName;
    const cardHolderNameError = craditCardErrors.cardHolderName;
    const cardHolderNameMsg = generateTag(formErrorsLang, cardHolderNameError && cardHolderNameTouched ? cardHolderNameError : '');

    if (!hasPayment) {
        return null;
    }

    return (
        <FormSection>
            <SectionTitle title={title} />

            <div className='row'>
                <div className='col-12 col-xs-12 col-md-4 col-lg-3'>
                    <InputGroup
                        name={'craditCard.cardNumber'}
                        type='number'
                        label={cardNumberLabel}
                        value={craditCardDetails.cardNumber}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={cardNumberMsg}
                    />
                </div>
                <div className='col-4 col-xs-4 col-md-3 col-lg-2'>
                    <SelectInput
                        name={'craditCard.cardExpireDateYY'}
                        label={cardExpireYearLabel}
                        value={craditCardDetails.cardExpireDateYY}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        selects={yearsSelectOption}
                        required={true}
                        errorMsg={cardExpireYearMsg}
                    />
                </div>
                <div className='col-4 col-xs-4 col-md-3 col-lg-2'>
                    <SelectInput
                        name={'craditCard.cardExpireDateMM'}
                        label={cardExpireMonthLabel}
                        value={craditCardDetails.cardExpireDateMM}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        selects={monthsSelectOption}
                        required={true}
                        errorMsg={cardExpireMonthMsg}
                    />
                </div>
                <div className='col-4 col-xs-4 col-md-2 col-lg-2 col-lg-1'>
                    <InputGroup
                        type='number'
                        name={'craditCard.cardAddedNumber'}
                        label={cardCVVLabel}
                        value={craditCardDetails.cardAddedNumber}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={cardCVVMsg}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-12 col-sm-12 col-md-3 col-lg-3'>
                    <InputGroup
                        type='number'
                        name={'craditCard.cardHolderId'}
                        label={cardHolderIdLabel}
                        value={craditCardDetails.cardHolderId}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={cardHolderIdMsg}
                    />
                </div>
                <div className='col-12 col-xs-12 col-md-4 col-lg-3'>
                    <InputGroup
                        name={'craditCard.cardHolderName'}
                        label={cardHolderNameLabel}
                        value={craditCardDetails.cardHolderName}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={cardHolderNameMsg}
                    />
                </div>
            </div>
        </FormSection>
    );
}

export default CreditCardFormSection;